import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalHeaderTitle,
  Text,
} from '@antoree/ant-ui';
import React from 'react';
type Props = {
  title: string;
  content: string;
  close: () => void;
  func: () => void;
  isLoading?: boolean;
  hideAction?: boolean;
  extraActions?: React.ReactNode;
};
const Notice = ({ title, content, close, func, isLoading, hideAction, extraActions }: Props) => {
  return (
    <div>
      <Modal onClose={close}>
        <ModalHeader>
          <ModalHeaderTitle>
            <Text className="text-xl">{title}</Text>
          </ModalHeaderTitle>
        </ModalHeader>
        <ModalBody>{content || 'Chưa có nội dung'}</ModalBody>
        <ModalFooter>
          {!hideAction && (
            <>
              <Button onClick={close} fill className=" mr-auto" color="danger">
                <Text>No</Text>
              </Button>
              <Button onClick={func} fill isLoading={isLoading}>
                <Text>Yes</Text>
              </Button>
            </>
          )}
          {extraActions && extraActions}
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Notice;
